module.exports = __webpack_public_path__ + "img/login-logo.a031d1b2.png";